var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.href)?_c('a',{staticClass:"link-arrow",class:_vm.additionalClasses,attrs:{"href":_vm.href}},[_c('ArrowCircle'),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})],1):_c('div',{staticClass:"link-arrow",class:_vm.additionalClasses},[_c('ArrowCircle'),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b26f2f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/Sites/AT/assets/js/vue/components/partials/LinkArrow.vue
// module id = 107
// module chunks = 0 1